export default {
    methods: {
        getRepresentativeFullName(representative) {
            if (representative) {
                return `${representative.first_name || ''} ${representative.last_name || ''}`
            }

            return '-'
        }
    }
}


// WEBPACK FOOTER //
// ./client/mixins/presentationHelpers.js